import { render, staticRenderFns } from "./orderBackMoney.vue?vue&type=template&id=034127cb&scoped=true"
import script from "./orderBackMoney.vue?vue&type=script&lang=js"
export * from "./orderBackMoney.vue?vue&type=script&lang=js"
import style0 from "./orderBackMoney.vue?vue&type=style&index=0&id=034127cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034127cb",
  null
  
)

export default component.exports